import React, { useEffect } from 'react'
import { getRole } from '../../utils/cookies/cookies'
import AdminDashboard from './AdminDashboard/index'
import HRDashboard from './HRDashboard/index'
import StaffDashboard from './StaffDashboard'
import axiosAuthInstance from '../../utils/axios/axiosAuthInstance'
import { usePermissions } from '../../context/permission';

const Home = () => {
  const role = getRole()
  const { updatePermissions } = usePermissions();

  const getPermission = async () => {
    await axiosAuthInstance
      .get('team/current-user-permission')
      .then((response) => {
        updatePermissions(response.data?.result);
      })
      .catch((error) => {
        console.error('Failed to fetch permissions:', error);
      });
  }

  // useEffect(() => {
  //   if (role != 'admin') {
  //     getPermission()
  //   }
  // }, [])

  const renderDashboard = () => {
    switch (role) {
      case 'admin':
        return <AdminDashboard />
      case 'HR':
      case 'Team Leader':
      case 'Social Media Coordinator':
        return <HRDashboard />
      default:
        return <StaffDashboard />
    }
  }

  return (
    <>
      {renderDashboard()}
    </>
  )
}

export default Home
